import DeptTreeV3 from './src/main';

/* istanbul ignore next */
DeptTreeV3.install = function(Vue) {
  Vue.component(DeptTreeV3.name, DeptTreeV3);
};

export default DeptTreeV3;
